import {
  Button,
  Flex,
  Img,
  Link,
  Modal,
  ModalContent,
  ModalOverlay,
  useToast
} from '@chakra-ui/react'
import { useCallback, useEffect, useState } from 'react'

import { User } from '../../generated/graphql'
import { ERROR_TOAST, SUCCESS_TOAST } from '../../constants'
import { getJWT } from '../../helpers/auth'

type TermsAndConditionsPropsType = {
  user: User
}

const TermsAndConditionsModal = ({ user }: TermsAndConditionsPropsType) => {
  const toast = useToast()
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const handleClose = () => {
    setIsOpen(false)
  }

  const handleSaveTermsAccepted = useCallback(async () => {
    setLoading(true)

    const API_BASE_URL = process.env.REACT_APP_API_HOST

    const response = await fetch(`${API_BASE_URL}/user/update`, {
      method: 'POST',
      body: JSON.stringify({ email: user.email, acceptedTermsAndConditions: true }),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getJWT()
      }
    })

    if (response.status >= 400) {
      toast({
        description: 'Oops, failed to accept terms and conditions',
        ...ERROR_TOAST
      })
    }

    const result = await response.json()

    if (result.status === 'success') {
      await localStorage.setItem(
        'termsAccepted',
        JSON.stringify({ termsAccepted: true, email: user.email! })
      )
      toast({
        description: 'Successefully accepted Ts&Cs.',
        ...SUCCESS_TOAST
      })
    } else {
      toast({
        description: 'Oops, failed to accept terms and conditions',
        ...ERROR_TOAST
      })
    }

    setLoading(false)
    setIsOpen(false)
  }, [user, toast])

  useEffect(() => {
    const CheckTermsAccepted = async () => {
      // Check if the terms and conditions have been accepted on local storage
      const localStorageTermsAccepted = (await localStorage.getItem('termsAccepted')) || ''

      // If  local storage item is found, check the user and compare the email
      if (localStorageTermsAccepted) {
        const { termsAccepted: termsAcceptedValue, email } = JSON.parse(localStorageTermsAccepted)
        let isAccepted = termsAcceptedValue && email === user.email
        setIsOpen(!isAccepted)
        return
      }
      console.log('could not find local storage item')

      // if no local storage item is found, check the user object from dynamoDB
      const isUserTermsAccepted = user.acceptedTermsAndConditions
      if (isUserTermsAccepted) {
        // If user has accepted terms and conditions,
        await localStorage.setItem(
          'termsAccepted',
          JSON.stringify({ termsAccepted: true, email: user.email! })
        )
        // close the modal
        setIsOpen(false)
      }

      //If no Terms and conditions accepted, open the modal
      setIsOpen(true)
    }
    CheckTermsAccepted()
  }, [user.email, user.acceptedTermsAndConditions])

  return (
    <Modal
      isCentered
      blockScrollOnMount={true}
      isOpen={isOpen}
      size={'2xl'}
      onClose={handleClose}
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay backdropFilter="auto" backdropBlur="2px" />

      <ModalContent
        bgColor={'#ffc801'}
        alignItems={'center'}
        justifyContent={'center'}
        rounded={'full'}
        padding={25}
        shadow={'none'}
        width={'100%'}
        height={'100%'}
        maxH={['300px', '500px', '500px', '500px', '500px']}
        maxW={['300px', '500px', '500px', '500px', '500px']}
      >
        <Img
          src={'/images/GoSolr_WebAppDesign_TsCs.png'}
          objectFit="cover"
          w={'full'}
          boxSize={['85%', '95%', '95%', '95%', '95%']}
          // shadow={'lg'}
          rounded={'full'}
          top={0}
          pos={'absolute'}
        />

        <Flex
          pos={'absolute'}
          direction={'column'}
          alignItems={'center'}
          gap={['10px', '15px', '15px', '15px', '15px']}
          bottom={['10%', '10%', '10%', '10%', '10%']}
        >
          <Link
            fontWeight={400}
            fontSize={['smaller', 'md', 'lg', 'xl', 'xl']}
            href="https://gosolr-static-files.s3.eu-west-1.amazonaws.com/gosolr_website_terms.pdf"
            color="black"
            target={'_blank'}
            textDecor={'underline'}
          >
            Terms & conditions
          </Link>

          <Button
            color={'#ffbe00'}
            bgColor={'#000000'}
            rounded={'full'}
            onClick={(e) => handleSaveTermsAccepted()}
            fontSize={['smaller', 'md', 'lg', 'xl', 'xl']}
            isLoading={loading}
            maxW={'min-content'}
            // padding={['10px', '15px', '15px', '', '']}
            variant={'dark'}
          >
            Accept
          </Button>
        </Flex>
      </ModalContent>
    </Modal>
  )
}

export default TermsAndConditionsModal
